<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'StatisticsRadioGroup',
    componentName: 'StatisticsRadioGroup',
    props: {
      value: {}
    }
  }
</script>

<style scoped>

</style>
